import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import { ClientCollection } from "..";

var AbstractPostCollection = /*#__PURE__*/function (_ClientCollection) {
  _inherits(AbstractPostCollection, _ClientCollection);

  var _super = _createSuper(AbstractPostCollection);

  function AbstractPostCollection() {
    _classCallCheck(this, AbstractPostCollection);

    return _super.apply(this, arguments);
  }

  return AbstractPostCollection;
}(ClientCollection);

export { AbstractPostCollection };